import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '../Profile.styles';

const AlertGridItemWrapper = ({
  message,
  status,
}: {
  message: string;
  status: string;
}) => {
  const { t: translate } = useTranslation('account');

  return (
    <S.AlertGridItem fullWidth>
      {message === translate('profile.messages.confirm_email_update_success') ||
      status === 'success' ? (
        <S.AlertContainer alertType="success" message={message} />
      ) : null}
      {message === translate('profile.messages.confirm_email_update_error') ||
      status === 'failed' ? (
        <S.AlertContainer alertType="failed" message={message} />
      ) : null}
    </S.AlertGridItem>
  );
};

export default AlertGridItemWrapper;
